export default __webpack_public_path__ + "static/media/swf-footer-mobile.5b618061.jpg";